import { cssTransition } from 'react-toastify';

export const disabledToastTransition = cssTransition({
  enter: 'no-toast-transition',
  exit: 'no-toast-transition',
  collapse: false
});
